import React from 'react'
import BDDashboard from './BD_dashboard'

const index = () => <BDDashboard />

export default index